import { isPlatformServer } from '@angular/common';
import {
  Injectable,
  PLATFORM_ID,
  makeStateKey,
  TransferState,
  inject,
} from '@angular/core';
import { Request, Response } from 'express';
import UAParser from 'ua-parser-js';
import { REQUEST, RESPONSE } from '../../express.tokens';

@Injectable({
  providedIn: 'root',
})
export class UserAgent {
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  private request = inject<Request>(REQUEST, { optional: true });
  private response = inject<Response>(RESPONSE, { optional: true });

  isMobileDevice(): boolean {
    return this.getUserAgent().getDevice().type !== undefined;
  }

  getUserAgent(): UAParser.UAParserInstance {
    if (isPlatformServer(this.platformId)) {
      throw new Error(
        'getUserAgent() cannot be used on the server as it will have unexpected effects due to the User-Agent not being part of the cache key in Varnish',
      );
    }
    return new UAParser(window.navigator.userAgent);
  }

  isBot(): boolean {
    const stateKey = makeStateKey<boolean>('isBot');

    if (isPlatformServer(this.platformId)) {
      // We set this header in Fastly. See D157516
      const isBot = this.request?.get('X-User-Agent-Bot') === 'true';
      this.transferState.set(stateKey, isBot);
      this.response?.append('Vary', 'X-User-Agent-Bot');

      return isBot;
    }

    return this.transferState.get(stateKey, false);
  }
}
